import { StudentDebtStoreService } from '@hb/modules/financial-obligations/student-debt/student-debt-store.service';
import { QuestionKey } from '@hb/modules/global/global.constants';
import { AmountFormControl } from '@hb/domain';
import { CoApplicantPipe } from '@hb/modules/global';
import { AnalyticsService } from '@hb/services/analytics/analytics.service';
import { AdditionalInfoComponent, NextButtonComponent } from '@hb/modules';
import { GLOBAL_STORE, GlobalInjectComponent, QUESTION_KEY } from '@hb/modules/global/abstract-global-inject.component';

import { Component, inject, OnInit } from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';

import { ApContentPipe } from '@ap/content';
import { ApAmountInputComponent } from '@ap/input/amount';

@Component({
    selector: 'student-debt-amount',
    imports: [CoApplicantPipe, ApContentPipe, ApAmountInputComponent, AdditionalInfoComponent, NextButtonComponent, ReactiveFormsModule],
    templateUrl: './student-debt-amount.component.html',
    providers: [
        { provide: GLOBAL_STORE, useExisting: StudentDebtStoreService },
        { provide: QUESTION_KEY, useValue: QuestionKey.STUDENT_DEBT_TOTAL }
    ]
})
export class StudentDebtAmountComponent extends GlobalInjectComponent<StudentDebtStoreService> implements OnInit {
    protected readonly analyticsService = inject(AnalyticsService);
    protected readonly store = inject(StudentDebtStoreService);

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.mainApplicantControl = new AmountFormControl<string>(
            this.analyticsService,
            this.store.getAmount()?.amount.toString(),
            this.questionKey
        );
        this.mainApplicantControl.onUpdate().subscribe((amount: string) => {
            this.store.setAmount(amount);
        });
    }
}
